import * as types from "../types";

export const submitUpdateBidStatusRequest = ({accessToken, bid_status_id, bid_status}) => ({
    type: types.SUBMIT_UPDATE_BID_STATUS_REQUEST,
    payload:{
        accessToken,
        bid_status_id,
        bid_status
    }
})

export const submitUpdateBidStatusSuccess = ({updateBidStatusRes}) => ({
    type: types.SUBMIT_UPDATE_BID_STATUS_SUCCESS,
    payload:{
        updateBidStatusRes   
    }
})

export const submitUpdateBidStatusFailure = ({error}) => ({
    type: types.SUBMIT_UPDATE_BID_STATUS_FAILURE,
    payload: {
        error: error
    }
});

export const submitUpdateBidStatusReset = () => ({
    type: types.SUBMIT_UPDATE_BID_STATUS_RESET
});